import React from 'react';
import { GestureConflictHandleView } from '../GestureConflictHandleView';
import { ViewStyle } from 'react-native';

export function HorizontalGestureConflictView(props: { children: any; style?: ViewStyle | ViewStyle[] }) {
    return (
        <GestureConflictHandleView canScrollLeft canScrollRight style={props.style}>
            {props.children}
        </GestureConflictHandleView>
    );
}
